import { Geometry, registerGeometry } from "aframe";
import { CapsuleGeometry } from "three";

type CapsuleData = {
	radius : number,
	height : number,
	segmentsHeight : number,
	segmentsRadial : number
};

registerGeometry("capsule", {
	schema : {
		height: {default: 1, min: 0},
		radius: {default: 0.5, min: 0},
		segmentsHeight: {default: 18, min: 1, type: 'int'},
    segmentsRadial: {default: 36, min: 3, type: 'int'}
	},

	init(this : Geometry<CapsuleData>, data : CapsuleData )
	{
		this.geometry = new CapsuleGeometry(data.radius, data.height, data.segmentsHeight, data.segmentsRadial  )
	}
});

